var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form-group',{attrs:{"validator":_vm.validations[_vm.name],"label":_vm.label,"validator-params":_vm.validatorParams},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-textarea',_vm._g(_vm._b({attrs:{"outlined":"","dense":"","value":_vm.value}},'v-textarea',Object.assign({}, _vm.attrs, errors),false),_vm.listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }